(function () {
  var cfgEl = document.getElementById('spx-attribution-config');
  if (!cfgEl) return;
  var cfg;
  try {
    cfg = JSON.parse(cfgEl.textContent || '{}');
  } catch (err) {
    return;
  }
  if (!cfg || cfg.enabled === false || !cfg.collectorUrl) return;

  var ALLOWED = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'gclid',
    'gbraid',
    'wbraid',
    'fbclid',
  ];
  var SESSION_MINUTES = 30;
  var VISITOR_DAYS = 90;
  var PAID_MEDIUM = {
    cpc: 1,
    ppc: 1,
    paid: 1,
    paid_search: 1,
    'paid-search': 1,
    paid_social: 1,
    'paid-social': 1,
    cpm: 1,
    cpa: 1,
  };

  function uuid() {
    if (crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-xxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }

  function readConsent() {
    var api = window.Shopify && window.Shopify.customerPrivacy;
    if (!api) {
      return { analytics: 'unknown', marketing: 'unknown', source: 'unknown' };
    }
    try {
      if (typeof api.analyticsProcessingAllowed === 'function') {
        return {
          analytics: api.analyticsProcessingAllowed() ? 'granted' : 'denied',
          marketing:
            typeof api.marketingAllowed === 'function'
              ? api.marketingAllowed()
                ? 'granted'
                : 'denied'
              : 'unknown',
          source: 'shopify',
        };
      }
    } catch (err) {
      /* keep unknown */
    }
    return { analytics: 'unknown', marketing: 'unknown', source: 'shopify' };
  }

  function cookieGet(name) {
    var parts = ('; ' + document.cookie).split('; ' + name + '=');
    if (parts.length < 2) return '';
    return decodeURIComponent(parts.pop().split(';').shift() || '');
  }

  function cookieSet(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie =
      name +
      '=' +
      encodeURIComponent(value) +
      '; expires=' +
      expires +
      '; path=/; SameSite=Lax; Secure';
  }

  function isUuid(value) {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
      String(value || ''),
    );
  }

  function storedAid() {
    var value = cookieGet('spx_aid');
    return isUuid(value) ? value : '';
  }

  function storedVid() {
    var value = cookieGet('spx_vid');
    return isUuid(value) ? value : '';
  }

  function sessionGet(key) {
    try {
      return sessionStorage.getItem(key) || '';
    } catch (err) {
      return '';
    }
  }

  function sessionSet(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (err) {
      /* ignore quota */
    }
  }

  function pickParams() {
    var params = new URLSearchParams(window.location.search);
    var out = {};
    var found = false;
    ALLOWED.forEach(function (key) {
      var value = params.get(key);
      if (value) {
        out[key] = String(value).slice(0, 200);
        found = true;
      }
    });
    return { fields: out, found: found };
  }

  function referrerHost() {
    if (!document.referrer) return '';
    try {
      var host = new URL(document.referrer).hostname.toLowerCase();
      if (!host || host === window.location.hostname) return '';
      return host;
    } catch (err) {
      return '';
    }
  }

  function qualifies(fields, host) {
    if (fields.gclid || fields.gbraid || fields.wbraid || fields.fbclid) return true;
    if (fields.utm_source && fields.utm_medium && PAID_MEDIUM[fields.utm_medium.toLowerCase()]) {
      return true;
    }
    if (fields.utm_source || fields.utm_medium || fields.utm_campaign) return true;
    if (host) return true;
    return false;
  }

  function ids() {
    var now = Date.now();
    var cookieAid = storedAid();
    var sessionRaw = sessionGet('spx.session');
    var session = null;
    try {
      session = sessionRaw ? JSON.parse(sessionRaw) : null;
    } catch (err) {
      session = null;
    }
    if (
      !session ||
      !session.session_id ||
      !isUuid(session.attribution_id) ||
      now - Number(session.touched_at || 0) > SESSION_MINUTES * 60 * 1000
    ) {
      session = {
        session_id: uuid(),
        attribution_id: cookieAid || uuid(),
        touched_at: now,
      };
    } else {
      session.touched_at = now;
    }
    sessionSet('spx.session', JSON.stringify(session));
    return {
      visitor_id: storedVid() || null,
      session_id: session.session_id,
      attribution_id: session.attribution_id,
      hadStoredAid: Boolean(cookieAid),
    };
  }

  function persistIdentity(identity) {
    var visitorId = storedVid() || identity.visitor_id || uuid();
    cookieSet('spx_vid', visitorId, VISITOR_DAYS);
    cookieSet('spx_aid', identity.attribution_id, VISITOR_DAYS);
    identity.visitor_id = visitorId;
    return identity;
  }

  function landingQualifies() {
    var picked = pickParams();
    return qualifies(picked.fields, referrerHost());
  }

  function canBridge() {
    return Boolean(storedAid()) || landingQualifies();
  }

  function currentAttributionId() {
    if (!canBridge()) return '';
    return ids().attribution_id;
  }

  function lineProperties() {
    var id = currentAttributionId();
    if (!id) return null;
    return { _spx_attribution_id: id };
  }

  function ensureFormInputs() {
    var id = currentAttributionId();
    if (!id) return;
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var input = form.querySelector('[data-spx-line-prop]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[_spx_attribution_id]';
        input.setAttribute('data-spx-line-prop', '');
        form.appendChild(input);
      }
      input.value = id;
    });
  }

  function attachPropertiesToAddBody(body) {
    var props = lineProperties();
    if (!props || !body) return body;
    if (Array.isArray(body.items)) {
      body.items = body.items.map(function (item) {
        var next = Object.assign({}, item);
        next.properties = Object.assign({}, item.properties || {}, props);
        return next;
      });
      return body;
    }
    body.properties = Object.assign({}, body.properties || {}, props);
    return body;
  }

  var syncing = null;
  function syncCart() {
    var id = currentAttributionId();
    if (!id) return Promise.resolve(false);
    ensureFormInputs();
    if (syncing) return syncing;
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    syncing = fetch(String(root).replace(/\/?$/, '/') + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { __spx_attribution_id: id } }),
    })
      .then(function (res) {
        return res.ok;
      })
      .catch(function () {
        return false;
      })
      .then(function (ok) {
        try {
          sessionStorage.setItem('spx.bridge.last', ok ? 'ok' : 'fail');
        } catch (err) {
          /* ignore */
        }
        syncing = null;
        return ok;
      });
    return syncing;
  }

  function eventKey(attributionId, path, fields, host) {
    return ['spx.event', attributionId, path, host]
      .concat(ALLOWED.map(function (key) { return fields[key] || ''; }))
      .join('|');
  }

  function send(payload) {
    var url = String(cfg.collectorUrl).replace(/\/$/, '') + '/v1/collect';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
      mode: 'cors',
      credentials: 'omit',
    }).catch(function () {});
  }

  function run() {
    var consent = readConsent();
    var identity = ids();
    var picked = pickParams();
    var host = referrerHost();
    var qualified = qualifies(picked.fields, host);

    if (identity.hadStoredAid || qualified) {
      persistIdentity(identity);
      ensureFormInputs();
      syncCart();
    }

    if (!qualified) return;
    var path = window.location.pathname || '/';
    var key = eventKey(identity.attribution_id, path, picked.fields, host);
    var eventId = sessionGet(key) || uuid();
    sessionSet(key, eventId);

    var payload = {
      schema_version: 'spx.collect.v1',
      event_id: eventId,
      visitor_id: identity.visitor_id,
      session_id: identity.session_id,
      attribution_id: identity.attribution_id,
      occurred_at: new Date().toISOString(),
      consent: consent,
      landing_path: path,
      referrer_host: host || null,
    };
    ALLOWED.forEach(function (keyName) {
      payload[keyName] = picked.fields[keyName] || null;
    });
    send(payload);
  }

  var ran = false;
  function runOnce() {
    if (ran) return;
    ran = true;
    run();
  }

  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function () {
        runOnce();
      },
    );
    setTimeout(runOnce, 1500);
  } else {
    runOnce();
  }

  var rawFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : input && input.url;
      if (url && /\/cart\/add\.js(?:\?|$)/.test(url) && init && init.body) {
        init = Object.assign({}, init);
        if (typeof init.body === 'string') {
          var parsed = JSON.parse(init.body);
          init.body = JSON.stringify(attachPropertiesToAddBody(parsed));
        } else if (typeof FormData !== 'undefined' && init.body instanceof FormData) {
          ensureFormInputs();
          var lineId = currentAttributionId();
          if (lineId && !init.body.get('properties[_spx_attribution_id]')) {
            init.body.append('properties[_spx_attribution_id]', lineId);
          }
        }
      }
    } catch (err) {
      /* leave the add payload unchanged */
    }
    return rawFetch(input, init);
  };

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.querySelector) return;
      var checkout =
        form.id === 'CartDrawerCheckout' ||
        (((form.getAttribute('action') || '').indexOf('/cart') !== -1 &&
          (form.querySelector('[name="checkout"]') ||
            (e.submitter && e.submitter.getAttribute('name') === 'checkout'))));
      if (!checkout || form.getAttribute('data-spx-bridged') === '1') return;
      e.preventDefault();
      e.stopPropagation();
      syncCart().finally(function () {
        form.setAttribute('data-spx-bridged', '1');
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(e.submitter || undefined);
        } else {
          form.submit();
        }
      });
    },
    true,
  );

  document.addEventListener(
    'click',
    function (e) {
      var wallet =
        e.target &&
        e.target.closest &&
        e.target.closest(
          'shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .shopify-payment-button, [data-dynamic-checkout]',
        );
      if (!wallet) return;
      ensureFormInputs();
      syncCart();
    },
    true,
  );

  window.ShinplexAttribution = {
    id: currentAttributionId,
    syncCart: syncCart,
    lineProperties: lineProperties,
  };
})();
